import FormLogin from "components/FormLogin";
const Login = () => {
    return <div className="flex h-screen w-full items-center justify-center bg-[#212427]">
        <FormLogin />
    </div>
};

export default Login;
